import React, { type ReactElement, useEffect } from 'react'
import { useSnapshot } from 'valtio'
import Head from 'next/head'
import Script from 'next/script'
import { GlobalLoader } from '../../../../shared/components/ui/global/GlobalLoader'
import { PaymentError } from '../../../../shared/components/ui/global/PaymentError'
import Breadcrumbs from '../../../../shared/components/ui/breadcrumbs/Breadcrumbs'
import { determineBrowserTabName } from '../../../../shared/themes/logoFunctions'
import { Success } from './Success/Success'
import { PaymentConfiguration } from './components/PaymentConfiguration'
import { recurringPaymentNewProxy, resetRecurringPaymentNewProxy, clearApiErrors } from './recurringPaymentNewProxy'

//new success component to handle for success handling
export function NewRecurringPaymentMainContainer (): ReactElement {
  const { apiCallAddNewRecurringConfiguration, completed } = useSnapshot(recurringPaymentNewProxy)
  useEffect(() => resetRecurringPaymentNewProxy, [])
  return (
    <>
      <Head>
        <title>New Recurring Charge - {determineBrowserTabName()}</title>
      </Head>

      <Script src={process.env.NEXT_PUBLIC_ELAVON_CHECKOUT_JS_URL} />
      <Script src={process.env.NEXT_PUBLIC_ELAVON_LIGHTBOX_URL} />

      {apiCallAddNewRecurringConfiguration.loading && <GlobalLoader />}
      {apiCallAddNewRecurringConfiguration.error && (
        <PaymentError error={apiCallAddNewRecurringConfiguration.error} errorMessage={apiCallAddNewRecurringConfiguration.errorMessage} errorCode={apiCallAddNewRecurringConfiguration.errorCode} handleClearErrors={clearApiErrors} />
      )}
      <Breadcrumbs breadcrumbs={[{ text: 'Create New Recurring Charge' }]} />
      <div className="pt-8">
        {completed ? <Success /> : <PaymentConfiguration />}
      </div>
    </>
  )
}
